import React, { useState, useEffect, useRef } from "react";

import { Button, Row, Col, Input, Spin, message, Form } from "antd";
import { useNavigate } from "react-router-dom";

import { capitaliseWithHyphen, showErrorMessage } from "../../../utils";

import packetIcon from "../../../assests/images/packetIcon.svg";
import HubIcon from "../../../assests/images/HubIcon.svg";
import weightIcon from "../../../assests/images/weightLogo.svg";
import countIcon from "../../../assests/images/countLogo.svg";
import guideIcon from "../../../assests/images/guide.svg";
import checkIcon from "../../../assests/images/SVG/check.svg";
import crossIcon from "../../../assests/images/redCross.svg";
import packetContents from "../../../assests/images/packetContents.svg";
import shipmentTruck from "../../../assests/images/SVG/packetSurface.svg";
import planeIcon from "../../../assests/images/planeicon.svg";

import noPacketsIcon from "../../../assests/images/SVG/nopackets.svg";

import "./style.scss";

import urls from "../../../api/urls";
import API from "../../../api";

const { GET_CP_PACKETS, CREATE_PACKETS, UPDATE_PACKET } = urls;

const AddPacket = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const shipmentRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [manifestFor, setManifestFor] = useState();
  const [scannedIndex, SetScannedIndex] = useState();
  const [enableInput, setenableInput] = useState(true);
  const [currentScanNum, setcurrentScanNum] = useState([]);
  const [scannedNumbers, setScannedNumbers] = useState([]);

  const [allPackets, setAllPackets] = useState([]);
  const premiseId = JSON.parse(localStorage.getItem("userId"));

  const getTableData = async () => {
    setLoading(true);
    let response = await API.Api(GET_CP_PACKETS).getWithUserNPremiseHeader();
    if (response.status) {
      setLoading(false);
      let data = response?.response?.data;
      setAllPackets(data);
      // setAllPackets(x);
    } else {
      setLoading(false);
      showErrorMessage(response.response.data.message || "Network error");
    }
  };

  useEffect(() => {
    getTableData();
    setManifestFor(localStorage.getItem("manifestFor"));
  }, [manifestFor]);

  const shipmentIdMap =
    allPackets &&
    allPackets &&
    allPackets["createPacketDtos"]?.map((val) => val?.shipmentsAdded);

  const activepacket = shipmentIdMap?.twoDIndexOf(parseInt(currentScanNum));

  const findCurrentCard =
    allPackets &&
    allPackets &&
    allPackets["createPacketDtos"]?.find((val, idx) => {
      return idx === scannedIndex;
    });

  const filterCurrentAwbs = findCurrentCard?.shipmentsAdded;

  useEffect(() => {
    let checkScanNum =
      filterCurrentAwbs && filterCurrentAwbs?.includes(currentScanNum);

    if (checkScanNum) {
      if (scannedNumbers.includes(currentScanNum)) {
        
        return showErrorMessage(currentScanNum + " barcode already scanned");
      } else {
        setScannedNumbers((oldArray) => [
          ...oldArray,
          parseInt(currentScanNum),
        ]);
      }
    } else {
      if (scannedIndex !== undefined) {
        showErrorMessage(currentScanNum + " barcode not found in current packet");
      }
    }
    if (scannedIndex === undefined && activepacket !== -1) {
      SetScannedIndex(activepacket && activepacket[0]);
      setScannedNumbers((oldArray) => [...oldArray, parseInt(currentScanNum)]);
    }
  }, [currentScanNum]);

  useEffect(() => {
    if (currentScanNum.length === 0) {
      setenableInput(false);
    } else {
      setenableInput(true);
    }
  }, [scannedNumbers]);

  const filterTwoArrays = (arr1, arr2) => {
    return arr1?.filter((item) => !arr2.includes(item));
  };

  const unScannedAwbs = filterTwoArrays(filterCurrentAwbs, scannedNumbers);

  const handleUpdatePacket = async (params) => {
    let response = await API.Api(
      UPDATE_PACKET + params?.packetBarcode
    ).putIdHeader({
      status: "FINALISED",
    });
    if (response.status) {
      setLoading(false);
      getTableData();
    } else {
      setLoading(false);
      showErrorMessage(response?.response?.data?.message || "Network error");
    }
  };

  const handlecreatePackets = async (payload) => {
    setLoading(true);

    let response = await API.Api(CREATE_PACKETS).postIdHeader(payload);
    if (response.status) {
      setLoading(false);
      setScannedNumbers([]);
      setcurrentScanNum([]);
      SetScannedIndex(undefined);
      form.resetFields();

      shipmentRef.current.input.value = "";
      let res = response?.response?.data;
      message.success(`Packet with Id ${res?.packetBarcode} created`);
      handleUpdatePacket(res);
    } else {
      setLoading(false);
      showErrorMessage(response?.response?.data?.message || "Network error");
    }
  };

  function onFinish() {
    const createPacketPayload = {
      packetBarcode: findCurrentCard && findCurrentCard?.packetBarcode,
      service: findCurrentCard && findCurrentCard?.service,
      travelBy: manifestFor,
      toPremiseId: findCurrentCard?.toPremise,
      fromPremiseId: premiseId?.userInfo?.premiseId,
      packetShipments: scannedNumbers
        ?.filter((val) => val === val)
        ?.map((val) => {
          if (val !== null) {
            return { awbNo: val };
          }
        }),
    };

    handlecreatePackets(createPacketPayload);
    allPackets?.length === 0;
  }

  Array.prototype.twoDIndexOf = function (element) {
    if (this === null || this === undefined)
      throw TypeError("Array.prototype.indexOf called on null or undefined");
    for (let i = 0; i < this.length; i++) {
      const curr = this[i];
      if (curr?.includes(element)) return [i];
    }
    return -1;
  };

  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
    return scanned_barcode;
  };

  const handleNext = () => {
    navigate("/child-scan");
  };

  return (
    <Spin spinning={loading}>
      <div className="add-packet">
        <div>
          <div className="container">
            <div className="content-header">
              <Row>
                <Col lg={19}>Add packet ID</Col>

                <Col lg={5} align="end">
                  Total packet count:
                  <span>
                    {(allPackets && allPackets["createPacketDtos"]?.length) ||
                      0}
                  </span>
                </Col>
                <hr />
              </Row>
            </div>
            <div className="content-body">
              <Row align="center">
                {!allPackets?.createPacketDtos && (
                  <p className={"no-packets"}>
                    <>
                      <Row>
                        <img
                          src={noPacketsIcon}
                          style={{ margin: "30px auto" }}
                        />
                      </Row>
                      <Row>{"No eligible packets to be packeted"}</Row>
                    </>
                  </p>
                )}
                {allPackets &&
                  allPackets["createPacketDtos"]?.map((val, idx) => {
                    return (
                      <>
                        <Form onFinish={onFinish} className="mb-2">
                          <Col
                            lg={8}
                            // xs={12}
                            // md={12}
                            // xl={8}
                            className={
                              idx === scannedIndex
                                ? "active-cards cards"
                                : "cards"
                            }>
                            <Row>
                              <Col span={14}>
                                <Row className="row-one">
                                  {" "}
                                  <img src={packetIcon} /> Packet Id
                                </Row>
                                <Row className="row-two">
                                  <Form.Item
                                    // label="Id"
                                    name={"PId"}
                                    rules={[
                                      {
                                        required: false,
                                        message: "Id is required",
                                      },
                                    ]}>
                                    <Input
                                      disabled
                                      // ref={packetRef}
                                      defaultValue={val?.packetBarcode}
                                      value={val?.packetBarcode}
                                    />
                                  </Form.Item>
                                </Row>
                              </Col>
                              <Col span={8}>
                                <Row className="row-one">
                                  <Col span={23}>
                                    <img src={HubIcon} /> Hub
                                  </Col>
                                  <Col span={1}>
                                    {manifestFor === "air" ? (
                                      <img
                                        src={planeIcon}
                                        style={{ width: "25px" }}
                                      />
                                    ) : (
                                      <img
                                        src={shipmentTruck}
                                        style={{ width: "25px" }}
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <Row className="row-two">
                                  {capitaliseWithHyphen(
                                    allPackets?.parentHubName
                                  )}
                                </Row>
                              </Col>
                            </Row>
                            <Row style={{ marginBottom: "16px" }}>
                              <Col span={8}>
                                <Row className="row-one">
                                  {" "}
                                  <img src={weightIcon} /> Weight
                                </Row>
                                <Row className="row-two">
                                  {val?.weight?.toFixed(2)}kg
                                </Row>
                              </Col>
                              <Col span={6}>
                                <Row className="row-one">
                                  {" "}
                                  <img src={countIcon} /> Count
                                </Row>
                                <Row className="row-two">
                                  {val?.shipmentsAdded?.length}
                                </Row>
                              </Col>
                              <Col span={10}>
                                <Row className="row-one guide-name">
                                  {" "}
                                  <img src={guideIcon} />
                                  <span style={{ width: "70%" }}>
                                    Packeting guide name
                                  </span>
                                </Row>
                                <Row className="row-two">
                                  {capitaliseWithHyphen(
                                    val?.packetingGuideName
                                  )}
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Input
                                placeholder="Enter AWB number to scan"
                                style={{ width: "81%", margin: "10px auto" }}
                                // defaultValue={val?.packetBarcode}
                                disabled={idx !== scannedIndex && enableInput}
                                ref={shipmentRef}
                                maxLength={14}
                                onChange={(e) => {
                                  if (e.target.value.length > 9) {
                                    setcurrentScanNum(parseInt(e.target.value));
                                  }
                                }}
                              />
                            </Row>

                            <Row className="row-one">
                              <Col span={12}>
                                {" "}
                                <img src={packetContents} /> Packet contents
                              </Col>
                            </Row>
                            <Row className="content-items">
                              <Col span={2}></Col>
                              <Col span={22}>
                                <Row className="content-table-header">
                                  <Col span={15} className="awb-col">
                                    AWB No.
                                  </Col>
                                  <Col span={9}>Destination</Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row className="awb-destiny-row">
                              <Col span={2}></Col>
                              <Col className="awb-col-items" span={22}>
                                {val?.shipmentsAdded?.map((awbNum, index) => {
                                  return (
                                    <Row
                                      className="space-between"
                                      key={index}
                                      style={{ marginBottom: "14px" }}>
                                      <Col key={index} span={14}>
                                        {awbNum}
                                        {scannedNumbers?.includes(awbNum) ? (
                                          <img src={checkIcon} />
                                        ) : (
                                          <img src={crossIcon} />
                                        )}
                                      </Col>
                                      <Col key={index} span={10}>
                                        {capitaliseWithHyphen(val?.premiseName)}
                                      </Col>
                                    </Row>
                                  );
                                })}
                              </Col>
                            </Row>
                            <div className="close">
                              {idx === scannedIndex ? (
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  disabled={unScannedAwbs.length !== 0}>
                                  READY TO CLOSE
                                </Button>
                              ) : null}
                            </div>
                          </Col>
                        </Form>
                      </>
                    );
                  })}
              </Row>
              <Row className="submit">
                <Button
                  type="primary"
                  disabled={allPackets?.createPacketDtos?.length !== 0}
                  onClick={handleNext}>
                  NEXT
                </Button>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default AddPacket;
